export enum TYPES {
    DATA = '__DATA__',
    TYPE = '__type_of__',
    OPTIONS = '__OPTIONS__',
    FIELDS = '__FIELDS__',
    DEFAULTS = '__DEFAULTS__',
    COLLECTION = '__COLLECTION__',
    TYPES = '__TYPES__',
    NAME = '__NAME__',
    MODIFIED_PROPS = '__MODIFIED_PROPS__',
}
